import { useCopiedState } from "../../../../core/util/hooks";
import { OrderFilter } from "../../../domestic/orders/types";
import { setFilter, removeFilter, initialState } from "../../../domestic/orders/orderBookUXSlice";
import { invalidateOrders } from "../../../domestic/orders/orderBookDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import React from "react";

export const useOrderBookFilter = () => {
	const [storeFilter] = useCurrentOrderBookFilter();
	const [filter, editFilter, changeState, setCurrentFilter] = useCopiedState<OrderFilter>(storeFilter, true);

	const dispatch = useDispatch();
	const dispatchSetFilter = React.useCallback(() => {
		dispatch(setFilter(filter!));
		dispatch(invalidateOrders());
	}, [dispatch, filter]);

	const dispatchResetFilter = React.useCallback(() => {
		setCurrentFilter(initialState.filter)
	}, [setCurrentFilter]);

	return [filter, editFilter, dispatchSetFilter, changeState, dispatchResetFilter] as [
		typeof filter,
		typeof editFilter,
		typeof dispatchSetFilter,
		typeof changeState,
		typeof dispatchResetFilter
	];
};

export const useCurrentOrderBookFilter = () => {
	const filter = useSelector<StoreType, OrderFilter>(store => store.ux.domestic.orderBook.filter);
	const dispatch = useDispatch();
	const dispatchRemoveFilter = React.useCallback(
		(type: keyof OrderFilter) => {
			dispatch(removeFilter(type));
			dispatch(invalidateOrders());
		},
		[dispatch]
	);

	return [filter, dispatchRemoveFilter] as [typeof filter, typeof dispatchRemoveFilter];
};
